import React, { useEffect, useState } from 'react'
import './template-games.styles.scss'
import { getGameDataFromDb } from '@/utils/getDataFromDb'
import BackButton from '@/components/SHARED/back-button/back-button.component'
import { useNavigate } from 'react-router-dom'
import ImageContainer from '@/components/SHARED/image-container/image-container.component'

const AdminTemplateGames = ({
    owners,
    packageList,
    templateGames
}) => {

    const navigate = useNavigate();

    return (
        <div className='admin-template-games'>
            <div className='admin-template-games-content'>
                <BackButton cancel={() => navigate(-1)} />
                <div className="g-space-1"></div>
                <div className='section-title with-icon'>
                    <span>Template Games</span>
                </div>
                <hr />
                <div className='admin-template-games-content__sub'>
                    {
                        (templateGames && Object.keys(templateGames).length > 0)
                        ?
                        <div className='admin-template-games-list'>
                            <table className='g-table'>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Name</th>
                                        <th className='centered'>Elements</th>
                                        <th className='centered'>Teams</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        Object.keys(templateGames).map((gameId, index) => {
                                            const game = templateGames[gameId];
                                            return (
                                                <tr key={index}>
                                                    <td className='game-icon'>
                                                        <ImageContainer src={game.icon} alt={game.gameName} />
                                                    </td>
                                                    <td><h3>{game.gameName}</h3></td>
                                                    <td className='centered'>{game.createdElementTotal ?? 0}</td>
                                                    <td className='centered'>{game.createdTeams ?? 0}</td>
                                                    <td>
                                                        <div className='buttons'>
                                                            <button 
                                                                className='g-button small-btn'
                                                                onClick={() => navigate(`/admin/games/${gameId}`)}>
                                                                View
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                        :   
                        <div className='admin-template-games-list__empty'>
                            <span>No template games available</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default AdminTemplateGames